import { StyledModal } from '@app/components/modal/Modal';
import useTextAgentActions from '@app/hooks/text-agents/useTextAgentActions';
import type { AITextAgent } from '@app/services/text-agent.types';
import type { ModalProps } from 'antd';
import { TextAgentForm, type TextAgentFormValues } from './TextAgentForm';

export type TextAgentEditModalProps = ModalProps & {
    title?: string;
    data?: AITextAgent;
};

export const TextAgentEditModal = ({
    title = 'Edit AI Text Agent',
    data,
    onOk,
    ...props
}: TextAgentEditModalProps) => {
    const { editTextAgent } = useTextAgentActions();

    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    const handleSubmit = (values: TextAgentFormValues) => {
        if (data) {
            const formData = { ...values, id: data.id };
            editTextAgent.mutate(formData, {
                onSuccess: () => {
                    if (onOk) {
                        onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                    }
                },
            });
        }
    };

    return (
        <StyledModal title={title} width={680} footer={null} {...props}>
            <TextAgentForm
                id="ai-text-agent-edit"
                data={data}
                onCancel={props.onCancel}
                loading={editTextAgent.isPending}
                onSubmit={handleSubmit}
            />
        </StyledModal>
    );
};
